import { useCallback, useEffect, useMemo, useReducer, Reducer } from 'react';
import { initialState, createPopupState } from './utils';
export const UsePopupStateTriggers = {
  click: 'click',
  focus: 'focus',
  hover: 'hover'
};
const reducer = (_state, action) => {
  if (action) return action;
  return {
    visibleId: '',
    supportingHTMLElement: null
  };
};
export function usePopupState({
  triggers = [UsePopupStateTriggers.click],
  isTooltip = false
}) {
  const [state, toggleState] = useReducer(reducer, initialState);
  const {
    visibleId,
    supportingHTMLElement
  } = state;
  const popupState = useMemo(() => createPopupState({
    isTooltip,
    supportingHTMLElement,
    toggleState,
    triggers,
    visibleId
  }), [visibleId, triggers, supportingHTMLElement, isTooltip]);
  const handleClickOutside = useCallback(e => {
    if (!visibleId) return;
    const popup = document.getElementById(visibleId);
    const supportingElementValue = e.target.getAttribute('data-popup-value');
    if (supportingElementValue && visibleId && supportingElementValue.includes(visibleId) || popup && popup.contains(e.target)) {
      return;
    }
    popupState.onClose(e);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [visibleId]);
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    if (triggers.includes('click') && visibleId) {
      document.addEventListener('pointerdown', handleClickOutside);
      return () => {
        document.removeEventListener('pointerdown', handleClickOutside);
      };
    }
  }, [visibleId, handleClickOutside, triggers]);
  return popupState;
}